/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ old: NonNullable<unknown>, new: NonNullable<unknown> }} Partner_Activity_StorageInputs */



/**
* | output |
* | --- |
* | "Storage {old} → {new}" |
*
* @param {Partner_Activity_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_storage = /** @type {((inputs: Partner_Activity_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher ${i?.old} → ${i?.new}`)
	return /** @type {LocalizedString} */ (`Storage ${i?.old} → ${i?.new}`)
});